export default {
  setCheckout(state, checkout) {
    state.checkout = checkout
  },
}
